import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, Events, ModalController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the DetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html',
})
export class DetailPage {
  @ViewChild('headd') targetElement: any;
  @ViewChild('rowPrin') targetElement2: any;
  @ViewChild('foot') targetElement3: any;
  pedido: any = null
  middle: any = 0
  info: any = ''
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public viewCtrl : ViewController,
    public events: Events,
    public modal: ModalController,
    public http: HttpProvider
    ) {
  }

  ionViewDidEnter() {
    document.documentElement.style.setProperty(`--heightM`, 0 + 'px');
    this.pedido = this.navParams.get('pedido')
    setTimeout(function() {
      let midd = this.targetElement2.nativeElement.offsetHeight;
      let hdd = this.targetElement.nativeElement.offsetHeight;
      let fot = this.targetElement3.nativeElement.offsetHeight;
      let restante = midd - hdd - fot - 10
      document.documentElement.style.setProperty(`--heightM`, restante + 'px');
    }.bind(this), 100);
    console.log(this.pedido)
  }

  verObservacion() {
    this.alertCtrl.create({
      title: 'Observación',
      subTitle: this.pedido.descripcion,
      cssClass:'alrt',
      buttons:[
        {
          text:'Aceptar',
          cssClass: 'btnAceptar',
          handler:()=>{}
        }
      ]
    }).present()
  }

  calcularTotal(item) {
    // let iva = (parseFloat(item.iva) / 100) * parseFloat(item.precio.monto) * (item.cant)
    let total = (item.precio.monto * item.cant)  * parseFloat(item.equivalente)
    return this.transform(total)
  }

  atras() {
    this.navCtrl.pop()
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts